var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 20.7135C0.0500235 20.2865 0.0922968 19.8589 0.150775 19.4326C0.573509 16.3529 1.83114 13.6641 3.92367 11.3663C6.32339 8.73112 9.30014 7.13973 12.8152 6.5674C13.2992 6.48906 13.7903 6.45448 14.3004 6.39732V0L27 10.3585L14.318 20.7424V14.331C13.798 14.3867 13.3105 14.4164 12.8314 14.4947C9.62635 15.0162 6.86801 16.4178 4.59512 18.7466C3.40653 19.9647 2.44833 21.3458 1.78182 22.9224C1.24847 24.1849 0.702442 25.4425 0.161343 26.7008C0.116956 26.8045 0.056364 26.9005 0.00281775 27L0 20.7135Z","fill":"white"}));
}

Share.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = Share;

Share.default = Share;
